import angular from 'angular';
import ngSanitize from 'angular-sanitize';

import DefaultGrouping from './default';

import TruncateFilter from '../filters/truncate';

import SourceInfoServ from '../services/source-info';

class SourcesGrouping extends DefaultGrouping {
  constructor($rootScope, $sanitize, $filter, SourceInfoServ) {
    super();

    this.sanitize = $sanitize;
    this.filter = $filter;
    this.sourceInfo = SourceInfoServ;
    this.currentCase = $rootScope.currentCase;

    this.key = 'sources';
    this.displayName = "Sources";
    this.ungroupedName = 'No Sources';

    this.columnsByGroup = super.setColumns([
      'factDateish',
      'title',
      'content',
      'tags',
      'legalIssues',
      this.key,
      'contributors',
      'creationDate'
    ]);

    this.getSortingValue = this.getMemoText;
    this.getHeaderDisplayName = super.getDisplayName;
  }

  getDocDisplayStyles() {
    var result = super.getDocDisplayStyles();
    result['width'] = '16%';
    // required to wrap looong words
    result['word-wrap'] = 'break-word';
    result['word-break'] = 'break-all';
    return result;
  };
  getMarkup(source, icon, bookmark = null) {
    let page = bookmark && parseInt(bookmark.page);
    let link = page && !isNaN(page) ? `${source.link}#page=${page}` : source.link;
    let displayName = bookmark ? `${source.displayName}, p${bookmark.page}` :
      source.displayName;

    return [icon ?
      `<i class="table-source-icon ${this.sourceInfo.sourceTypes[source.format].icon}"></i> ` :
      '',
      link ? `<a href="${link}" target="_blank">` : '',
      icon ? displayName : this.filter('truncate')(displayName, 35),
      link ? '</a>' : ''
    ].join('');
  }
  getFactItems(sources, branchId, icon) {
    if (!sources) {
      return
    }
    let items = sources.filter(source => source.id !== branchId).map(source => {
      source = this.sourceInfo.getLink(source);
      if (source.bookmarks && source.bookmarks.length) {
        var bookmarks = [];
        source.bookmarks.sort((a, b) => {
          return parseInt(a.page) - parseInt(b.page);
        }).forEach(bookmark => {
          bookmarks.push(this.getMarkup(source, icon, bookmark));
        });
        return bookmarks;
      } else {
        return [this.getMarkup(source, icon)];
      }

    });
    return [].concat.apply([], items);
  };

  getDisplayText(sources, branchId) {
    return this.getFactItems(sources, branchId, true).join('<br />');
  };

  getMemoText(sources, branchId) {
    return this.getFactItems(sources, branchId).join(', ');
  };

  getDocDisplayText(sources, branchId) {
    var sources = this.currentCase.sources;

    return sources.map(function (id) {
      if (id !== branchId && sources[id]) {
        return '[' + this.sourceInfo.sourceTypes[sources[id].format].displayName +
          '] ' +
          this.sanitize(sources[id].displayName).
        replace(/([0-9A-Za-z])\.([0-9A-Za-z]{4})/g, '$1. $2').
        replace(/([0-9A-Za-z])([/&_?=+$%-])([0-9A-Za-z])/g, '$1$2 $3/');
      }
    }).join(',<br />');
  };

  getItemsByFact(fact) {
    var items = fact[this.key].map(function (item) {
      return item;
    });
    return items.length > 0 ? items : ['ungrouped'];
  };

  getOutlineText(branch) {
    // called from a Branch
    var result = branch.displayName;
    var s = this.currentCase.sources[branch.id];
    if (s && s.format === 'person') {
      result += s.role ? '<br/>' + s.role : '';
      result += s.phone ? '<br/>' + s.phone : '';
      result += s.email ? '<br/>' + s.email : '';
      result += s.address ? '<br/>' + s.address.replace(/\n/, '<br/>') : '';
    }
    return result;
  };

}
SourcesGrouping.$inject = ['$rootScope', '$sanitize', '$filter',
  'SourceInfoServ'
];

export default angular.module('groupings.sources-grouping', [SourceInfoServ,
    ngSanitize
  ])
  .service('SourcesGrouping', SourcesGrouping)
  .name;



// WEBPACK FOOTER //
// ./project/groupings/sources.js